/**
 * Today's challenge for Home (specs/home-page Story 2). The slate changes once a day (UTC midnight);
 * the 5-minute freshness mainly keeps match statuses current so a kicked-off match drops off the card.
 */

import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../helpers/apiClient.helper';
import { fetchTodaySlate } from '../helpers/homeApi';
import { homeQueryKeys } from '../constants/homeQueryKeys';
import { HOME_QUERY_STALE_TIME_MS, HOME_QUERY_GC_TIME_MS } from '../constants/home.constants';

export const useTodaySlateQuery = (enabled: boolean = true) => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: homeQueryKeys.slateToday(),
    queryFn: () => fetchTodaySlate(apiClient),
    enabled,
    staleTime: HOME_QUERY_STALE_TIME_MS,
    gcTime: HOME_QUERY_GC_TIME_MS,
    refetchInterval: HOME_QUERY_STALE_TIME_MS,
    refetchIntervalInBackground: false,
    retry: 2,
  });
};
